
import { useLanguage } from '../contexts/LanguageContext'

function ContactPageContent() {
    const { language } = useLanguage()
    const emailMe = 'awnlwt1ty@mozmail.com'
    
    if (language === 'eng') {
        return <>
            <h4>Contact Information</h4>
            <p>Email: {emailMe}</p>
            <p>GitHub: <a href="https://github.com/ArtNazarov" target="_blank" rel="noreferrer">github.com/ArtNazarov</a></p>
            <p>GitFlic: <a href="https://gitflic.ru/user/artnazarov" target="_blank" rel="noreferrer">gitflic.ru/user/artnazarov</a></p>
            <p>For business inquiries and collaboration proposals.</p>
        </>
    }
    
    // Russian version
    return <>
        <h4>Контактная информация</h4>
        <p>Email: {emailMe}</p>
        <p>GitHub: <a href="https://github.com/ArtNazarov" target="_blank" rel="noreferrer">github.com/ArtNazarov</a></p>
        <p>GitFlic: <a href="https://gitflic.ru/user/artnazarov" target="_blank" rel="noreferrer">gitflic.ru/user/artnazarov</a></p>
        <p>Для деловых предложений и предложений о сотрудничестве.</p>
    </>
}

export default ContactPageContent
 